export function isSameFilterValue(value1: unknown, value2: unknown): boolean {
  if (value1 == null && value2 == null) return true;
  if (value1 == null || value2 == null) return false;

  if (Array.isArray(value1) && Array.isArray(value2)) {
    if (value1.length !== value2.length) return false;
    return value1.every((v, i) => v === value2[i]);
  }

  if (typeof value1 === 'object' && typeof value2 === 'object') {
    return JSON.stringify(value1) === JSON.stringify(value2);
  }

  return value1 === value2;
}

export function isDuplicateFilter(filter: { criteriaKey: string; criteriaOperator: string; value: unknown }, existingFilters: Array<{ criteriaKey: string; criteriaOperator: string; value: unknown }>): boolean {
  return existingFilters.some(
    (f) =>
      f.criteriaKey === filter.criteriaKey &&
      f.criteriaOperator === filter.criteriaOperator &&
      isSameFilterValue(f.value, filter.value)
  );
}

export function findConflictingFilterIndex(
  filter: { criteriaKey: string; criteriaOperator: string; value: unknown },
  existingFilters: Array<{ criteriaKey: string; criteriaOperator: string; value: unknown }>
): number {
  return existingFilters.findIndex(
    (f) =>
      f.criteriaKey === filter.criteriaKey &&
      isSameFilterValue(f.value, filter.value) &&
      f.criteriaOperator !== filter.criteriaOperator
  );
}

